var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"holder"},[_c('span',{staticClass:"text"},[_vm._t("default",function(){return [_vm._v("ayyy")]})],2),_vm._v(" "),_c('span',{staticClass:"skeleton rounded",class:_vm.bgClass},[_c('div',{staticClass:"shimmer",style:(_vm.shimmerStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0bece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextSkeleton.vue
// module id = null
// module chunks = 